<script>
  import NumberInput from '@/widgets/NumberInput2.svelte';

  export let value = 0;
  export let countryCode = '';
  export let len = '20';
  export let haveNoCountryCode = false;
  export let code = 0;
</script>

<style>
  .phone {
    border: 1px solid #e5e5e5;
    border-radius: 8px;
    width: 100%;
  }
  .phone :global(span) {
    border: 0;
    border-radius: 0;
    padding: 0 14px;
    width: 100%;
  }
  .phone :global(input) {
    width: 100%;
    color: rgba(0, 0, 0, 0.85);
  }
  .code {
    border-right: 1px solid #e5e5e5;
    width: 80px;
  }
  .code .jia {
    top: -2px;
    left: 10px;
    height: 100%;
  }
  .jia-inp :global(input) {
    width: 20px;
    text-align: center;
  }
</style>

<div class="phone df">
  {#if haveNoCountryCode}
    <div class="code df aic pr">
      <div class="jia pa df aic">+</div>
      <div class="jia-inp pa">
        <NumberInput bind:valueEx={code} operation={false} len={4} showLabel={false} />
      </div>
    </div>
  {:else}
    <div class="code df aic jcc T3">{countryCode}</div>
  {/if}
  <NumberInput bind:valueEx={value} operation={false} showLabel={false} {len} on:blur />
</div>
